import { type Ref, computed, type ComputedRef } from 'vue'
import { assertNever } from '@/helpers'
import type { RingBuilderStoneTypes } from '@/domain/product/ring/ring-builder'
import type { MoneyFragment } from '@/graphql/api'

export interface TotalSaleAmount {
    totalSaleAmount: ComputedRef<MoneyFragment>
}

export const getTotalSaleAmount = (
    stone: RingBuilderStoneTypes | null | undefined
): MoneyFragment => {
    const defaultAmount: MoneyFragment = {
        __typename: 'Money',
        amount: '0',
        currency: 'GBP',
    }

    if (!stone) {
        return defaultAmount
    }

    switch (stone.__typename) {
        case 'GemsApi_Stone':
        // fallthrough
        case 'NonSkuGemstone':
        // fallthrough
        case 'NonSkuLabGrown':
            return stone.salePrice || defaultAmount
        default:
            return assertNever(stone, defaultAmount)
    }
}

export function useTotalSaleAmount(
    stone: Ref<RingBuilderStoneTypes | null | undefined>
): TotalSaleAmount {
    const totalSaleAmount = computed<MoneyFragment>(() =>
        getTotalSaleAmount(stone.value)
    )

    return {
        totalSaleAmount,
    }
}
